export default __webpack_public_path__ + "static/bepower-40a11c013f5157b1497f3b8cdf13dfd2.webp";